export class Audit {
  regrId?: string;
  regDate?: Date;
  regrNm?: string;
  chgrId?: string;
  chgDate?: Date;
}
